import { render } from "./d-prediction.vue?vue&type=template&id=6c4c2f75&scoped=true&ts=true"
import script from "./d-prediction.vue?vue&type=script&lang=ts"
export * from "./d-prediction.vue?vue&type=script&lang=ts"

import "./d-prediction.vue?vue&type=style&index=0&id=6c4c2f75&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c4c2f75"]])

export default __exports__